module.exports = __webpack_public_path__ + "static/media/oberflex-sapelli-2560x1440.210ae6e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-sapelli-2560x1440.jpg
// module id = 1055
// module chunks = 37